import sortBy from 'lodash/sortBy';
import identity from 'lodash/identity';
import {createSelector} from 'reselect';

export const getUserById = (state, id) => state.user.users[id];

export const selectUserIdsByChannelId = (state, channelId) =>
  Array.from(state.user.byChannelId[channelId] || []);

export const selectUsersByChannelId = (state, channelId) => {
  const users = selectUserIdsByChannelId(state, channelId)
    .map(id => getUserById(state, id))
    .filter(identity);
  return sortBy(users, 'displayName');
};

export const isUserLoading = (state, id) =>
  state.user.isLoadingUserById.has(id);

export const selectUserDetailsById = (state, id) => state.user.details[id];

export const isUserDetailsLoading = (state, id) =>
  state.user.isLoadingUserDetailsById.has(id);

export const selectCardStatisticsById = (state, id) =>
  state.user.cardStatisticsById[id];

export const selectAllUserIds = createSelector(
  state => state.user.allUserIds,
  allUserIds => [...allUserIds]
);

export const selectAllUsersOffset = state => state.user.allUserIds.size;
